import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Login from './components/Login/Login';
import Header from './components/Header';
import Contact from './components/Contact';
import Conection from './components/Conection';
import Artistas from './components/Artistas/Artistas';
import Vr from './components/vr/vr';
import Loading from './components/vr/loading';
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // Duración de la animación en milisegundos

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="app-container">
        <Header />
        {loading ? (
          <div className="loading-container">
            <Loading />
          </div>
        ) : (
          <Routes>
            {/* Después de la animación de carga, redirige al Login */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route exact path="/vr" element={<Vr />} />
            <Route exact path="/contacto" element={<Contact />} />
            <Route exact path="/colecciones" element={<Conection />} />
            <Route exact path="/artistas" element={<Artistas />} />
            <Route exact path="/home" element={<Home />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
